// Keep editor nodes self-contained; deduplicate artwork at the persistence boundary.
export function packArtwork(doc) {
  const assets = {}, ids = new Map();
  const pages = doc.pages.map((p) => ({ ...p, elements: p.elements.map((n) => {
    if (n.type !== "image") return n;
    const src = n.src || doc.assets?.[n.assetId];
    if (!ids.has(src)) {
      const id = `art${ids.size}`;
      ids.set(src, id);
      assets[id] = src;
    }
    const { src: unused, ...node } = n;
    return { ...node, assetId: ids.get(src) };
  }) }));
  return { ...doc, assets, pages };
}
export function unpackArtwork(doc) {
  if (!doc?.assets || !Array.isArray(doc.pages)) return doc;
  const { assets, ...rest } = doc;
  return { ...rest, pages: doc.pages.map((p) => ({ ...p, elements: p.elements.map((n) => {
    if (n.type !== "image" || !n.assetId) return n;
    const { assetId, ...node } = n;
    return { ...node, src: assets[assetId] };
  }) })) };
}
